import React from 'react';
import classNames from 'classnames';

import Field from 'components/Field';
import Input from 'components/Input';
import styles from './PersonalisedMenteeEmailersLearnerInput.module.scss';

export default function PersonalisedMenteeEmailersLearnerInput({
  label,
  value,
  placeholder,
  handleChange,
  name,
  prefixName,
  errors,
}) {
  return (
    <Field
      label={label}
      className={styles.inputHeader}
      name={name}
      prefixName={prefixName}
      clientErrors={errors}
    >
      <Input
        className={classNames(styles.entityInput, 'p-b-xxs')}
        onChange={handleChange}
        value={value}
        placeholder={placeholder}
      />
    </Field>
  );
}
